import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';

import { SleepioWellnessOnboardingParams } from '../../SleepioWellnessOnboardingPage';

import BaseErrorState from '@/components/BaseErrorState';
import { isSpark } from '@/utils/productHelpers';

const ExpiredLinkError: React.FC = () => {
  const { t } = useTranslation();
  const { product, slug } = useParams<SleepioWellnessOnboardingParams>();
  const history = useHistory();

  const handleBackToStart = () => {
    let normalizedProduct = product;
    if (product) {
      normalizedProduct = isSpark(product) ? 'spark' : 'sleepio';
    }
    history.push(`/activate/${normalizedProduct}/${slug}`);
  };

  return (
    <BaseErrorState
      onButtonClick={handleBackToStart}
      title={t('coverage.pre_onboarding.sleepio.expired_link_error.title')}
      subtitle={t('coverage.pre_onboarding.sleepio.expired_link_error.subtitle')}
      buttonText={t('coverage.pre_onboarding.sleepio.expired_link_error.button_text')}
      supportEmail={t('coverage.pre_onboarding.sleepio.expired_link_error.support.email')}
      supportText={t('coverage.pre_onboarding.sleepio.expired_link_error.support.text')}
    />
  );
};

export default ExpiredLinkError;
